import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
var PastProjects = /*#__PURE__*/function (_Component) {
  function PastProjects(props) {
    var _this;
    _classCallCheck(this, PastProjects);
    _this = _callSuper(this, PastProjects, [props]);
    _this.state = {
      expanded: false
    };
    _this.toggleShowMore = _this.toggleShowMore.bind(_this);
    return _this;
  }
  _inherits(PastProjects, _Component);
  return _createClass(PastProjects, [{
    key: "toggleShowMore",
    value: function toggleShowMore() {
      var expanded = this.state.expanded;
      this.setState({
        expanded: !expanded
      });
    }
  }, {
    key: "renderSeeMore",
    value: function renderSeeMore() {
      var expanded = this.state.expanded;
      return /*#__PURE__*/React.createElement("a", {
        className: "body-text-2 expand-projects mt-2",
        onClick: this.toggleShowMore,
        role: "link",
        tabIndex: 0
      }, expanded ? 'See Less' : 'View all projects');
    }
  }, {
    key: "render",
    value: function render() {
      var projects = this.props.projects;
      var expanded = this.state.expanded;
      var visibleProjects = expanded ? projects : projects.slice(0, 3);
      return /*#__PURE__*/React.createElement("div", {
        className: "past-projects",
        id: "past-projects"
      }, /*#__PURE__*/React.createElement("div", {
        className: "past-projects-overview"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row--always header"
      }, /*#__PURE__*/React.createElement("h2", null, "Past Projects on Clora"))), /*#__PURE__*/React.createElement("div", null, visibleProjects.map(function (project) {
        return /*#__PURE__*/React.createElement("div", {
          className: "project",
          key: project.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "mb-12"
        }, /*#__PURE__*/React.createElement("h3", {
          className: "project-name"
        }, project.name), /*#__PURE__*/React.createElement("p", {
          className: "body-text-2"
        }, project.company)));
      }), projects.length > 3 ? this.renderSeeMore() : ''));
    }
  }]);
}(Component);
PastProjects.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default PastProjects;